export default function D3Message ({text}) {
  const texts = (String(text)).split('\n').map(item => {
    return (
      <>
        {item}<br />
      </>
    );
  });
  return (<>{texts}</>);
}